import BaseDataService from "./BaseDataService";

class APIDataService extends BaseDataService {
  constructor(name) {
    super(name)
    this.moduleName = 'apis'
  }

  search(payload) {
    return this.http.get(`/${this.moduleName}`, { params: payload });
  }

  save(payload) {
    return this.http.post(`/clone/apis`, payload);
  }

  playground(id) {
    if (localStorage['user'] && JSON.parse(localStorage['user'])['Token']) {
      this.http.defaults.headers['Authorization'] = "Bearer " + JSON.parse(localStorage['user'])['Token']
    }
    return this.http.get(`/${this.moduleName}/${id}/playground`);
  }
  createBulk(payload) {
    if (localStorage['user'] && JSON.parse(localStorage['user'])['Token']) {
      this.http.defaults.headers['Authorization'] = "Bearer " + JSON.parse(localStorage['user'])['Token']
    }
    return this.http.post('/apis-multiple', payload)
  }
}

export default new APIDataService();